import React from 'react';
import styled from 'styled-components';

import { CtaButton } from '../styled';

const Container = styled.div`
  padding: 0 25px;
`

const HomepageDocInner = styled.div`
  max-width: 990px;
  padding: 20px 0 20px;
  margin: 0 auto;
  text-align: center;
  border-radius: 12px;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);
  margin-bottom: 50px;
  background-image: url(${(props) => props.imgUrl});
  background-repeat: no-repeat;
  background-size: 100% 100%;
`;

const Headline = styled.p`
  max-width: 750px;
  margin: 0 auto;
  margin-bottom: 14px;
  font-weight: bold;
  font-size: 20px;
  color: #2d59f8;
`;

const Headtitle = styled.span`
  padding-right: 7px;
`;

const Subheadline = styled.div`
  color: #4a4a4a;
  max-width: 600px;
  margin: 0 auto;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  letter-spacing: 0.54px;
`;

const PrimaryCtaButton = styled(CtaButton)`
  background: #2d59f8;
  color: #ffffff;
  margin-top: 20px;
  width: 180px;
  height: 40px;
  line-height: 39px;
  text-transform: none;

  &:hover {
    background: #3f81df;
  }

  &:active {
    background: #133a71;
  }
`;

const ItemsDocLink = styled.a`
  text-decoration: none;
  color: #fff;
  width: 100%;
  height: 100%;
  display: block;
`;

function HomepageDoc({ input }) {
    return (
        <Container>
        <HomepageDocInner imgUrl={input.items[0].backgroundimg.url}>
            <Headline>
              <Headtitle>{input.primary.tokenname.text}</Headtitle>
              {input.primary.tokencontent.text}
            </Headline>
            <Subheadline>{input.primary.desc.text}</Subheadline>
            <PrimaryCtaButton>
              <ItemsDocLink href={input.items[0].docurl.url} target="_blank">{input.items[0].docname.text}</ItemsDocLink>
            </PrimaryCtaButton>
        </HomepageDocInner>
        </Container>
    );
}

export { HomepageDoc };
